import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from '../../core/interfaces/cell-renderer.interface';
import { BusinessPartnerDisplayComponent } from '../../../business-partner-display/business-partner-display.component';

@Component({
  selector: 'app-business-partner-cell-renderer',
  standalone: true,
  imports: [CommonModule, BusinessPartnerDisplayComponent],
  template: `
    <app-business-partner-display
      [soldTo]="soldTo"
      [shipTo]="shipTo"
      [customerType]="customerType"
      [showIcons]="true"
      [compact]="true"
      [displayMode]="'vertical'">
    </app-business-partner-display>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
  `]
})
export class BusinessPartnerCellRendererComponent implements CellRenderer<any> {
  @Input() params!: CellRendererParams<any>;

  get soldTo(): any {
    return this.params?.data?.soldTo ?? null;
  }

  get shipTo(): any {
    return this.params?.data?.shipTo ?? null;
  }

  get customerType(): string | undefined {
    return this.params?.data?.shipToType;
  }
}
